export default {
    dependencies: ['$element'],
    callable(ele) {
        const createNoteButton = ele.querySelector('[data-create-note]');
        const submitFormButton = ele.querySelector('[data-submit-form]');
        const cancelFormButton = ele.querySelector('[data-cancel-form]');
        const input = ele.querySelector('[data-note-input]');
        const form = ele.querySelector('form');

        if (form && submitFormButton && cancelFormButton && createNoteButton) {
            form.addEventListener('submit', () => {
                submitFormButton.disabled = true;
                cancelFormButton.disabled = true;
            });

            createNoteButton.addEventListener('click', toggle);
            cancelFormButton.addEventListener('click', toggle);
        }

        function toggle() {
            toggleVisibility(createNoteButton);
            toggleVisibility(form);
            const parentChildren = ele.parentNode.children;
            for (let i = 0; i < parentChildren.length; i++) {
                if (parentChildren[i] !== ele) {
                    toggleVisibility(parentChildren[i]);
                }
            }
        }

        function toggleVisibility(target) {
            const isVisible = !target.classList.toggle('hidden');

            if (isVisible) {
                target.removeAttribute('aria-hidden');
                if (input) {
                    input.focus();
                }
            } else {
                target.setAttribute('aria-hidden', 'true');
                ele.focus();
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoriteNoteCreate.js